'use strict';

/** @type {import('.')} */
module.exports = Error;



//////////////////
// WEBPACK FOOTER
// ./~/.pnpm/es-errors@1.3.0/~/es-errors/index.js
// module id = 625
// module chunks = 0